import * as actionTypes from "./actionTypes";
import * as actionsTypes from "../../baseApp/users/actionTypes";

const searchVisits = searchFields => ({
    type: actionTypes.VISIT_SEARCH_REQUEST,
    searchFields
});

const checkOutSelectEntries = visitIds => ({
    type: actionTypes.VISIT_CHECK_OUT_REQUEST,
    visitIds
});

const createVisit = checkInData => ({
    type: actionTypes.CREATE_VISIT_REQUEST,
    checkInData
});

const checkInSelectedEntries = visitIds => ({
    type: actionTypes.VISIT_CHECK_IN_REQUEST,
    visitIds
});

const resetVisitForm = () => ({
    type: actionsTypes.RESET_USER_FORM
});

const resetVisitsTable = () => ({
    type: actionTypes.RESET_VISITS_RESULTS
});

const getVisitorLastVisits = visitorId => ({
    type: actionTypes.VISITOR_LAST_VISITS_REQUEST,
    visitorId
});

export default {
    searchVisits,
    createVisit,
    checkOutSelectEntries,
    checkInSelectedEntries,
    resetVisitForm,
    resetVisitsTable,
    getVisitorLastVisits
}